import type { User } from "firebase/auth";
import { mountDungeonPage } from "@/mount-dungeon-page";

let activeClose: (() => void) | null = null;

/** Dungeon builder lobby as overlay on home. */
export async function openDungeonModal(user: User): Promise<() => void> {
  if (activeClose) return activeClose;

  const overlay = document.createElement("div");
  overlay.className = "tower-modal dungeon-modal";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-label", "ด่านป้องกัน");

  const backdrop = document.createElement("button");
  backdrop.type = "button";
  backdrop.className = "tower-modal-backdrop";
  backdrop.setAttribute("aria-label", "ปิด");

  const shell = document.createElement("div");
  shell.className = "tower-modal-shell";
  overlay.append(backdrop, shell);
  document.body.appendChild(overlay);
  document.body.classList.add("has-tower-modal");

  let pageTeardown: (() => void) | null = null;

  const close = () => {
    pageTeardown?.();
    pageTeardown = null;
    overlay.remove();
    document.body.classList.remove("has-tower-modal");
    activeClose = null;
    window.removeEventListener("keydown", onKeyDown);
  };

  activeClose = close;
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") close();
  };
  window.addEventListener("keydown", onKeyDown);
  backdrop.addEventListener("click", () => close());

  pageTeardown = await mountDungeonPage(shell, user, {
    asModal: true,
    onRequestClose: close,
  });

  return close;
}
